import {env} from '@/config';

const {DEEPLINK_PREFIX, MATRIX_SERVER_URL_SUFFIX} = env;

export const MATRIX_REDIRECT_URL = `http://localhost:3000/matrix.auth`;
export const REDIRECT_WITH_LOGIN_TOKEN_REGEXP = new RegExp(
  `^${DEEPLINK_PREFIX}:\\/\\/matrix.auth\\?loginToken=([^~]+)$`
);
export const MATRIX_SERVER_URL = `https://${MATRIX_SERVER_URL_SUFFIX}`;
export const MATRIX_URL_SUFFIX = 'matrix.sportjoe.net';
export const MATRIX_URL = `https://${MATRIX_URL_SUFFIX}`;
export const MATRIX_KEYCLOAK_IP_ID = 'oidc-keycloak';
